export default __webpack_public_path__ + "static/me-d2b133598bbf02777a85ad5232f12df3.jpeg";